import { isEqual } from 'lodash';
import { PropTypes } from 'prop-types';
import * as queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { hasRole, RoleTypes } from '../../../core/components/Permission';
import Tabs from '../../../core/components/Tabs';
import {
  findPermissionRef,
  viewPermissionRefs,
} from '../../../core/components/UserGroupPermissions';
import { PermissionKeys } from '../../../core/components/UserPermissions';
import { selectPermissions, selectRole, selectUserGroup } from '../../../store/authReducer';
import Utilities from './Utilities';
import UserGroupPermissions from '../../../core/components/UserGroupPermissions';
import { selectActiveUtilities } from '../../settings/reducer';

export const component = (props) => {
  const [tabType, setTabType] = useState('water');
  const history = useHistory();
  const params = useParams();
  const intl = useIntl();
  const permissions = useSelector(selectPermissions);
  const userGroup = useSelector(selectUserGroup);
  const currentRole = useSelector(selectRole);
  const utilities = useSelector(selectActiveUtilities);
  const [tabs, setTabItems] = useState([]);
  const [currentTab, setCurrentTab] = useState('Water');
  const [tabExists, setTabExists] = useState(false);

  const getTabsProps = () => ({
    tabs: tabs,
    onClick: setUtility,
    selectedType: currentTab,
  });

  const setUtility = setCurrentTab;

  const setTabs = () => {
    if (
      hasRole(currentRole, RoleTypes.OperatorGroupAdmin) ||
      findPermissionRef(userGroup.permissions, viewPermissionRefs.expense)
    ) {
      return setUtility(tabExists ? currentTab : tabs[0].type);
    }
    const viableTab = tabs.find((t) => permissions[t.permissionKey]);
    if (!viableTab) {
      history.push(`/${params.site}/overview`);
    } else {
      setUtility(viableTab.type);
    }
  };

  useEffect(() => {
    if (tabs.length > 0) {
      setTabs();
    }
  }, [permissions, tabs]);

  useEffect(() => {
    let newTabs = [];
    let currentTabExists = false;
    if (utilities.Water && !utilities.WaterSewer) {
      newTabs.push({
        title: intl.formatMessage({ id: 'water' }),
        permissionKey: viewPermissionRefs.expense || PermissionKeys.viewUtilsTab,
        type: 'Water',
      });
      if (currentTab == 'Water') {
        currentTabExists = true;
      }
    }
    if (utilities.Electric) {
      newTabs.push({
        title: intl.formatMessage({ id: 'electric' }),
        permissionKey: viewPermissionRefs.expense || PermissionKeys.viewUtilsTab,
        type: 'Electric',
      });
      if (currentTab == 'Electric') {
        currentTabExists = true;
      }
    }
    if (utilities.Gas) {
      newTabs.push({
        title: intl.formatMessage({ id: 'gas' }),
        permissionKey: viewPermissionRefs.expense || PermissionKeys.viewUtilsTab,
        type: 'Gas',
      });
      if (currentTab == 'Gas') {
        currentTabExists = true;
      }
    }
    if (utilities.Sewer && !utilities.WaterSewer) {
      newTabs.push({
        title: intl.formatMessage({ id: 'sewer' }),
        permissionKey: viewPermissionRefs.expense || PermissionKeys.viewUtilsTab,
        type: 'Sewer',
      });
      if (currentTab == 'Sewer') {
        currentTabExists = true;
      }
    }
    if (utilities.WaterSewer) {
      newTabs.push({
        title: intl.formatMessage({ id: 'WaterSewer' }),
        permissionKey: viewPermissionRefs.expense || PermissionKeys.viewUtilsTab,
        type: 'WaterSewer',
      });
      if (currentTab == 'WaterSewer') {
        currentTabExists = true;
      }
    }
    setTabItems(newTabs);
    setTabExists(currentTabExists);
  }, [utilities]);

  return (
    <div className="container-fluid">
      <Tabs {...getTabsProps()} />
      <section className="page-main-content">
        <div>
          <UserGroupPermissions
            itemRef={viewPermissionRefs.expense}
            minRole={RoleTypes.SiteManager}
          >
            <Utilities pageFilter={currentTab} permissions={permissions} />
          </UserGroupPermissions>
        </div>
      </section>
    </div>
  );
};

component.propTypes = {
  filter: PropTypes.string,
  permissions: PropTypes.shape({}),
};

export const Expenses = React.memo(component, isEqual);

export default connect(null, null)(Expenses);
